import { $t } from "@/lib/i18nHelpers";
import { FormFields, ListField } from "@/types";

export const systemName = "gusto";

export const listField: ListField = { value: systemName, text: $t("ADP") };

export const formFields: FormFields = [
  {
    name: "email",
    label: $t("ADP email address"),
    rules: ["required"],
    validationMode: "aggressive",
  },
];
